export const ERROR_MESSAGES = {
  KYC: {
    EMAIL_REQUIRED: 'Please enter an email address',
    EMAIL_INVALID: 'Please enter a valid email address',
    MOBILE_REQUIRED: 'Please enter your mobile number',
    MOBILE_INVALID_LENGTH: 'Mobile number must be between 6 and 15 digits',
    FIRST_NAME_REQUIRED: 'Please enter your first name',
    LAST_NAME_REQUIRED: 'Please enter your last name',
    COUNTRY_REQUIRED: 'Please select a country',
    DATE_OF_BIRTH_REQUIRED: 'Please select your date of birth',
    SSN_REQUIRED: 'Please enter your SSN / National ID',
    PASSPORT_REQUIRED: 'Please enter your passport number',
    ADDRESS_REQUIRED: 'Please enter your address',
    CITY_REQUIRED: 'Please enter your city',
    STATE_REQUIRED: 'Please select your state',
    ZIP_CODE_REQUIRED: 'Please enter your zip code',
    ZIP_CODE_INVALID: 'Please enter a valid zip code',
  },
  TRYCATCH: {
    DEFAULT_FALLBACK_MESSAGE: "Sorry something went wrong. Please try again later.",
  }
} as const;